<template>
  <div class="informations-block">
    <div class="sidebar">
      <ul>
        <li v-for="option in options" :key="option.id">
          <div class="information-arrow" @click="toggleSubMenu(option)">
            {{ option.name }}
            <v-icon v-if="option.submenu" small v-on="on">fa fa-caret-down</v-icon>
          </div>
          <ul v-if="option.submenu && option.isExpanded">
            <li v-for="subOption in option.submenu" :key="subOption.id" @click="selectOption(subOption)">
              {{ subOption.name }}
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="content">
      <h2>{{ selectedOption.name }}</h2>
      <hr style="margin:1rem 0; width: 100%;" />
      <div v-if="selectedOption.content" v-html="selectedOption.content"></div>
      <component v-else :is="selectedOption.component" v-bind="selectedOption.props"></component>
    </div>
  </div>
</template>

<script>
export default {
  name: "InformationsBlock",
  data() {
    return {
      options: [
        {
          id: 1,
          name: `${this.$t("esic.who_we_are.name")}`,
          content: `${this.$t("esic.who_we_are.content")}`,
          submenu: null,
          isExpanded: false
        },
        {
          id: 2,
          name: `${this.$t("esic.institution_name.name")}`,
          content: `${this.$t("esic.institution_name.content")}`,
          isExpanded: false,
          submenu: null
        },
        {
          id: 3,
          name: `${this.$t("esic.certificates.name")}`,
          content: `${this.$t("esic.certificates.content")}`,
          isExpanded: false,
          submenu: null
        },
        {
          id: 4,
          name: `${this.$t("esic.leaders.name")}`,
          content: `${this.$t("esic.leaders.content")}`,
          isExpanded: false,
          submenu: null
        },
        {
          id: 5,
          name: `${this.$t("esic.public_agencies.name")}`,
          content: `${this.$t("esic.public_agencies.content")}`,
          isExpanded: false,
          submenu: null
        },
        {
          id: 6,
          name: `${this.$t("esic.statute.name")}`,
          content: `${this.$t("esic.statute.content")}`,
          isExpanded: false,
          submenu: null
        },
        {
          id: 7,
          name: `${this.$t("esic.esic.name")}`,
          content: `${this.$t("esic.esic.content")}`,
          isExpanded: false,
          submenu: null
        },
        {
          id: 8,
          name: `${this.$t("esic.public_partners.name")}`,
          content: `${this.$t("esic.public_partners.content")}`,
          isExpanded: false,
          submenu: null
        },
        {
          id: 9,
          name: `${this.$t("esic.organizational_structure.name")}`,
          content: `${this.$t("esic.organizational_structure.content")}`,
          isExpanded: false,
          submenu: null
        },
        {
          id: 10,
          name: `${this.$t("esic.faq.name")}`,
          content: `${this.$t("esic.faq.content")}`,
          isExpanded: false,
          submenu: null
        },
        {
          id: 11,
          name: `${this.$t("esic.contact.name")}`,
          content: `${this.$t("esic.contact.content")}`,
          isExpanded: false,
          submenu: null
        },
        {
          id: 12,
          name: `${this.$t("esic.cnpj.name")}`,
          content: `${this.$t("esic.cnpj.content")}`,
          isExpanded: false,
          submenu: null
        },
        {
          id: 13,
          name: `${this.$t("esic.address.name")}`,
          content: `${this.$t("esic.address.content")}`,
          isExpanded: false,
          submenu: null
        }
      ],
      selectedOption: {
        id: 1,
        name: `${this.$t("esic.who_we_are.name")}`,
        content: `${this.$t("esic.who_we_are.content")}`,
        submenu: null,
        isExpanded: false
      }
    };
  },
  created() {
    const query = this.$route.query.activeTab;
    this.selectedOption = this.options.find(option => option.name === query) || this.options[0];
  },
  watch: {
    "$route.query.activeTab": {
      immediate: true,
      handler(newVal) {
        const option = this.options.find(option => option.name === newVal);
        if (option) {
          this.selectOption(option);
        }
      }
    }
  },
  methods: {
    toggleSubMenu(option) {
      if (option.submenu) {
        option.isExpanded = !option.isExpanded;
      } else {
        this.selectOption(option);
      }
    },
    selectOption(option) {
      this.selectedOption = option;
      this.options.forEach(opt => {
        if (opt.submenu) opt.isExpanded = false;
      });
      this.$router.push({ query: { activeTab: option.name } });
    }
  }
};
</script>

<style>
.informations-block {
  display: flex;
}

.information-arrow {
  display: flex;
  justify-content: space-between;
}

.sidebar {
  width: 25vh;
  background-color: #f5f5f5;
  padding: 20px;
}

.sidebar ul {
  list-style: none;
  padding: 0;
}

.sidebar ul li div {
  cursor: pointer;
  padding: 10px 0;
  border-bottom: 1px solid #ddd;
}

.sidebar ul li:hover {
  background-color: #e7e7e7;
}

.content {
  flex-grow: 1;
  padding: 20px;
  background-color: #fff;
  width: 75vh;
}
</style>
